/**
 * @desc 查询品种交易排名
 */
import { KindRankingDto, KindRankingQuery } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryKindRankingParameter = KindRankingQuery

const method = 'GET'
const url = '/trade/order/mall/queryKindRanking'

export const queryKindRankingApi = (
  params?: QueryKindRankingParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<KindRankingDto>>({
    method,
    url,
    params,
    ...config
  })
}

queryKindRankingApi.method = method
queryKindRankingApi.url = url
